import React from "react";
import Aurio from "./aurio.jsx";
import ErrorBoundary from "./ErrorBoundary.jsx";
import InstallPrompt from "./InstallPrompt.jsx";

/* Thin shell around the imported prototype — adds crash safety and an
   install banner. The update chip/banner live in the app header now. */
export default function App() {
  return (
    <ErrorBoundary>
      <Aurio />
      <InstallPrompt />
    </ErrorBoundary>
  );
}
